module.exports = __webpack_public_path__ + "static/media/dictionary.5266e97b.svg";